// src/utils/chatHelpers.js
import * as chatService from '../services/chatService';

/**
 * Keep signature getOrCreateChat({ buyerId, sellerId, productId })
 * so existing OfferModal continues to work.
 */
const sanitize = (v) => {
  if (!v && v !== 0) return null;
  const s = String(v);
  return s.includes('/') ? s.split('/').pop() : s;
};

export const getOrCreateChat = async ({ buyerId, sellerId, productId }) => {
  const pid = sanitize(productId);
  const res = await chatService.findOrCreateChat(String(buyerId), String(sellerId), pid);
  // return consistent shape { id }
  return { id: res.chatId || res.id };
};
